var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPhoneDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4282 2.69362L19.3951 2.67297L15.2186 0.615356L10.7107 6.62586L12.7847 9.39133C12.7226 10.4343 12.2803 11.4182 11.5416 12.157C10.8028 12.8958 9.8188 13.338 8.77587 13.4001L6.01045 11.3261L0 15.8339L2.04049 19.9755L2.05767 20.0105L2.07836 20.0435C2.18725 20.2189 2.33923 20.3636 2.51984 20.4637C2.70046 20.5638 2.90368 20.616 3.11018 20.6154H4.18787C6.26435 20.6154 8.3205 20.2064 10.2389 19.4117C12.1573 18.6171 13.9005 17.4524 15.3687 15.9841C16.837 14.5158 18.0017 12.7727 18.7964 10.8542C19.591 8.93581 20 6.87966 20 4.80318V3.72544C20.0007 3.51895 19.9485 3.31572 19.8484 3.13511C19.7483 2.9545 19.6036 2.80251 19.4282 2.69362ZM18.4566 4.80318C18.4566 12.671 12.0556 19.0719 4.18787 19.0719H3.31584L1.95059 16.3004L6.01074 13.2553L8.27122 14.9506H8.52845C10.0681 14.9488 11.5441 14.3365 12.6328 13.2478C13.7215 12.1591 14.3338 10.6831 14.3356 9.14346V8.88624L12.6403 6.62581L15.685 2.5659L18.4566 3.93139V4.80318Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhoneDark);
export default __webpack_public_path__ + "static/media/icon_phone_dark.ea9bf978ca313213dd7aae254bc6929d.svg";
export { ForwardRef as ReactComponent };